import React from 'react';
import Checkbox from './Checkbox';

class LocationFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = { locationCheckboxes: [] };
    }

    handleChange = (event) => {
        let locationCheckboxes = this.props.locationCheckboxes
        locationCheckboxes.forEach(location => {
            if (location.id === event.target.id) {
                location.isChecked = event.target.checked
            }
        });
        this.setState({ locationCheckboxes: locationCheckboxes });
        this.props.onChange(event);
    }

    render() {
        let countriesRendered = [];
        return (
            <div >
                <input type="checkbox" id="chkAllLocations" name="chkAllLocations" value="checkedall" defaultChecked onChange={this.props.checkAllLocations} />
                <em><label className="checkbox-label" htmlFor="chkAllLocations">Check / Uncheck All</label></em>
                <ul>
                    {
                        this.props.locationCheckboxes.map((location) => {
                            if (location.id !== "WEB" && location.id !== "E994" && location.id !== "E700" && location.id !== "E998" && location.id !== "E701" && location.id !== "E702" && location.isVisible) {
                                if (countriesRendered.includes(location.country)) {
                                  
                                    return  (<Checkbox name="chkLocation" key={location.id} onChange={this.props.onChange}  {...location} />)
                                
                                } 
                                
                                
                                
                                else {
                                    countriesRendered.push(location.country);
                                    /*React demands a key, even for the span */

                                        {/* 4/27/23 YO: Poznan was added !!!.  Workaround!! Delete below when section was created for new locations 
                                            2/2/23 YO : Fix on checkbox glitches (Country should be in the Database in order to see site locations in website) 
                                            06/26/23 YO: Keep those work arounds till further notice   

                                   */ }

                                                                    {/* ///////////////// */}


                                    // if(location.country === "Poland")
                                    // {
                                    //     return <><span key={location.country}><strong>{location.country}</strong><br /> <Checkbox name="chkLocation" onChange={this.props.onChange}  {...location}  />
                                    //     <Checkbox name="chkLocation" onChange={this.props.onChange} {...location} value="Poznań" /> 
                             
                                    //     {/* <Checkbox name="chkLocation" onChange={this.props.onChange} {...location} value="Powidz FOS" />
                                    //     <Checkbox name="chkLocation" onChange={this.props.onChange} {...location} value="Zagan FOS" />                                                                     */}
                                    //     </span>                                                  
                                    //     </>                                       
                                    // }                                    
                                
                                                                     {/* ///////////////// */}
                                   
                                    return (<span key={location.country}><strong>{location.country}</strong><br /><Checkbox name="chkLocation" key={location.id} onChange={this.props.onChange}  {...location} /></span>)                                  
                                }
                            } 
                           
                            
                            
                            else {
                                return null; //React demands a return
                            }

                        })
                    }
                </ul>
            </div>
        );
    }
}

export default LocationFilter;
